const CONFIGURED_HOST = (process.env.NEXT_PUBLIC_HOST || "").replace(
  /^https?:\/\//,
  "",
);
const PRODUCTION_SERVICE_HOST = "www.chesshotel.com";

const isLocalHost = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)(:\d+)?$/.test(
  CONFIGURED_HOST,
);

export const USE_PROD = !isLocalHost;

export function getConfiguredHost() {
  return CONFIGURED_HOST;
}

export function getServiceHost() {
  if (!USE_PROD || process.env.NEXT_PUBLIC_TEST === "true") {
    return CONFIGURED_HOST;
  }

  return PRODUCTION_SERVICE_HOST;
}
